export const COST_REDUCTION_ANALYSIS = 'CostReductionAnalysis';
export const BUSINESS_TRIP_ANALYSIS = 'BusinessTripAnalysis';

export const STATISTICS_ROUTE_ID = 'statistics';
export const BASE_PATH = '/statistics';
export const COST_REDUCTION_ANALYSIS_PATH = '/statistics/cost-analysis';
export const BUSINESS_TRIP_ANALYSIS_PATH = '/statistics/business-analysis';

export const STATISTICS_ROUTE_PATHS = [
    BASE_PATH,
    COST_REDUCTION_ANALYSIS,
    BUSINESS_TRIP_ANALYSIS,
];

export const STATISTICS_ROUTE_INFO = {
    [COST_REDUCTION_ANALYSIS]: {
        title: '비용 절감 분석',
        label: '비용 절감 분석',
    },
    [BUSINESS_TRIP_ANALYSIS]: {
        title: '출장 통계',
        label: '출장 통계',
    },
};

export enum STATISTICS_DATE_TYPE {
    CHECKOUT = 'CHECKOUT', // 입실일
    MONTHLY = 'MONTHLY', // 월별
}

// 권역
export enum STAY_TYPE {
    INSTAY = 'INSTAY', // 국내
    EXSTAY = 'EXSTAY', // 해외
}
